import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasEmptySkillSelected.meta';

export type UseTrackCanvasEmptySkillSelectedParams = {
  slash_command: string;
  outcome_id: string;
  canvas_id: string;
};

export const useTrackCanvasEmptySkillSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasEmptySkillSelected = useCallback(
    (params: UseTrackCanvasEmptySkillSelectedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasEmptySkillSelected };
};
